module.exports = __webpack_public_path__ + "static/media/digital.8212e868.png";